<script>
  export let formatNumber, getClassName;
  export let displayValue, key, title, description;
  export let compareMode = false;
</script>

<div
  class="relative flex items-center justify-center flex-grow-0 flex-shrink-0 w-8 h-8 font-extrabold whitespace-no-wrap bg-gray-100 text-body-small"
>
  <p>{formatNumber(displayValue)}</p>
  <div
    class="progress absolute {getClassName(displayValue, key)}-gradient bottom-0 left-0 w-full"
    style="height:3px"
  ></div>
</div>

{#if !compareMode}
  <div>
    <p class="font-extrabold body-text-small">{title}</p>
    <p class="mt-1 tracking-wide">{description}</p>
  </div>
{/if}
